export default {
    SELECT: (state, payload) => {
        state[payload.key] = payload.value;
    },
    LAUNCH_RESEARCH: (state, payload) => {
        state.launch_research = payload.launch;
    },
};